import axios from "axios";

import { createTicketFromPMSApiRoute } from "../apiRoutes";

export function generateTicketApi(data, token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;

  return axios
    .post(createTicketFromPMSApiRoute, data)
    .then(res => res)
    .catch(err => err.response);
}
